(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deepsire-selected-products-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deepsire-product-carousel')) {
    customElements.define('deepsire-product-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        if (!this.track || !this.slides.length) return;
        this.controller = new AbortController();
        this.index = 0;
        this.startIndex = 0;
        this.previous = this.querySelector('[data-carousel-previous]');
        this.next = this.querySelector('[data-carousel-next]');
        this.counter = this.querySelector('[data-carousel-counter]');
        this.slides.forEach((slide) => {
          slide.removeAttribute('inert');
          slide.removeAttribute('aria-hidden');
        });
        const options = { signal: this.controller.signal };
        this.previous?.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next?.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
        }, options);
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let target;
          if (event.key === 'ArrowRight') target = this.index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') target = this.index + (rtl ? 1 : -1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.positions.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.goTo(target);
        }, options);
        this.track.addEventListener('focusin', (event) => {
          const slide = event.target.closest('[data-carousel-slide]');
          const index = this.slides.indexOf(slide);
          if (index < 0) return;
          const rect = slide.getBoundingClientRect();
          const view = this.track.getBoundingClientRect();
          if (rect.left < view.left - 1 || rect.right > view.right + 1) this.goToSlide(index, 'auto');
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target.closest('[data-carousel-slide]'));
          if (index >= 0) this.goToSlide(index, 'auto');
        }, options);
        this.width = this.track.clientWidth;
        this.observer = new ResizeObserver(() => {
          const width = this.track.clientWidth;
          if (width === this.width || width === 0) return;
          this.width = width;
          this.goToSlide(this.startIndex, 'auto');
        });
        this.observer.observe(this.track);
        this.goTo(0, 'auto');
        this.sync();
      }
      measure() {
        const view = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const scroll = rtl ? -this.track.scrollLeft : this.track.scrollLeft;
        const limit = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const rects = this.slides.map((slide) => slide.getBoundingClientRect());
        this.rtl = rtl;
        this.slidePositions = rects.map((rect) => {
          const delta = rtl ? view.right - rect.right : rect.left - view.left;
          return Math.max(0, Math.min(limit, scroll + delta));
        });
        this.positions = this.slidePositions.filter((position, index, positions) => index === 0 || Math.abs(position - positions[index - 1]) > 1);
        return { view, rects, scroll };
      }
      moveTo(position, behavior) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.rtl ? -position : position, behavior: reduced ? 'auto' : behavior });
      }
      goTo(index, behavior = 'smooth') {
        this.measure();
        const target = Math.max(0, Math.min(this.positions.length - 1, index));
        this.moveTo(this.positions[target], behavior);
      }
      goToSlide(index, behavior = 'smooth') {
        this.measure();
        if (this.slidePositions[index] !== undefined) this.moveTo(this.slidePositions[index], behavior);
      }
      sync() {
        const { view, rects, scroll } = this.measure();
        let nearest = 0;
        this.positions.forEach((position, index) => {
          if (Math.abs(position - scroll) < Math.abs(this.positions[nearest] - scroll)) nearest = index;
        });
        this.index = nearest;
        if (this.previous) this.previous.disabled = nearest === 0;
        if (this.next) this.next.disabled = nearest === this.positions.length - 1;
        let visible = rects.map((rect, index) => ({ rect, index })).filter(({ rect }) => rect.left >= view.left - 1 && rect.right <= view.right + 1);
        if (!visible.length) visible = rects.map((rect, index) => ({ rect, index })).filter(({ rect }) => rect.right > view.left && rect.left < view.right);
        const first = visible.length ? visible[0].index : 0;
        const last = visible.length ? visible[visible.length - 1].index : first;
        this.startIndex = first;
        if (this.counter) {
          const label = first === last
            ? this.counter.dataset.singleFormat.replace('__current__', String(first + 1))
            : this.counter.dataset.format.replace('__first__', String(first + 1)).replace('__last__', String(last + 1));
          if (this.counter.textContent !== label) this.counter.textContent = label;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.controller = null;
        this.frame = 0;
      }
    });
  }

  (function () {
    if (!window.matchMedia) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-card-zoom]').forEach(function (stage) {
      if (stage.dataset.zoomBound) return;
      stage.dataset.zoomBound = '1';
      var img = stage.querySelector('img');
      if (!img) return;
      stage.addEventListener('mouseenter', function () { stage.classList.add('is-zooming'); });
      stage.addEventListener('mouseleave', function () {
        stage.classList.remove('is-zooming');
        img.style.transformOrigin = '50% 50%';
      });
      stage.addEventListener('mousemove', function (event) {
        var rect = stage.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deepsire-selected-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deepsire-product-carousel')) {
    customElements.define('deepsire-product-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        if (!this.track || !this.slides.length) return;
        this.controller = new AbortController();
        this.index = 0;
        this.startIndex = 0;
        this.previous = this.querySelector('[data-carousel-previous]');
        this.next = this.querySelector('[data-carousel-next]');
        this.counter = this.querySelector('[data-carousel-counter]');
        this.slides.forEach((slide) => {
          slide.removeAttribute('inert');
          slide.removeAttribute('aria-hidden');
        });
        const options = { signal: this.controller.signal };
        this.previous?.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next?.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
        }, options);
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let target;
          if (event.key === 'ArrowRight') target = this.index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') target = this.index + (rtl ? 1 : -1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.positions.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.goTo(target);
        }, options);
        this.track.addEventListener('focusin', (event) => {
          const slide = event.target.closest('[data-carousel-slide]');
          const index = this.slides.indexOf(slide);
          if (index < 0) return;
          const rect = slide.getBoundingClientRect();
          const view = this.track.getBoundingClientRect();
          if (rect.left < view.left - 1 || rect.right > view.right + 1) this.goToSlide(index, 'auto');
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target.closest('[data-carousel-slide]'));
          if (index >= 0) this.goToSlide(index, 'auto');
        }, options);
        this.width = this.track.clientWidth;
        this.observer = new ResizeObserver(() => {
          const width = this.track.clientWidth;
          if (width === this.width || width === 0) return;
          this.width = width;
          this.goToSlide(this.startIndex, 'auto');
        });
        this.observer.observe(this.track);
        this.goTo(0, 'auto');
        this.sync();
      }
      measure() {
        const view = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const scroll = rtl ? -this.track.scrollLeft : this.track.scrollLeft;
        const limit = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const rects = this.slides.map((slide) => slide.getBoundingClientRect());
        this.rtl = rtl;
        this.slidePositions = rects.map((rect) => {
          const delta = rtl ? view.right - rect.right : rect.left - view.left;
          return Math.max(0, Math.min(limit, scroll + delta));
        });
        this.positions = this.slidePositions.filter((position, index, positions) => index === 0 || Math.abs(position - positions[index - 1]) > 1);
        return { view, rects, scroll };
      }
      moveTo(position, behavior) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.rtl ? -position : position, behavior: reduced ? 'auto' : behavior });
      }
      goTo(index, behavior = 'smooth') {
        this.measure();
        const target = Math.max(0, Math.min(this.positions.length - 1, index));
        this.moveTo(this.positions[target], behavior);
      }
      goToSlide(index, behavior = 'smooth') {
        this.measure();
        if (this.slidePositions[index] !== undefined) this.moveTo(this.slidePositions[index], behavior);
      }
      sync() {
        const { view, rects, scroll } = this.measure();
        let nearest = 0;
        this.positions.forEach((position, index) => {
          if (Math.abs(position - scroll) < Math.abs(this.positions[nearest] - scroll)) nearest = index;
        });
        this.index = nearest;
        if (this.previous) this.previous.disabled = nearest === 0;
        if (this.next) this.next.disabled = nearest === this.positions.length - 1;
        let visible = rects.map((rect, index) => ({ rect, index })).filter(({ rect }) => rect.left >= view.left - 1 && rect.right <= view.right + 1);
        if (!visible.length) visible = rects.map((rect, index) => ({ rect, index })).filter(({ rect }) => rect.right > view.left && rect.left < view.right);
        const first = visible.length ? visible[0].index : 0;
        const last = visible.length ? visible[visible.length - 1].index : first;
        this.startIndex = first;
        if (this.counter) {
          const label = first === last
            ? this.counter.dataset.singleFormat.replace('__current__', String(first + 1))
            : this.counter.dataset.format.replace('__first__', String(first + 1)).replace('__last__', String(last + 1));
          if (this.counter.textContent !== label) this.counter.textContent = label;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.controller = null;
        this.frame = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-rail-step]');
  if (!control) return;
  const rail = control.closest('[data-product-rail]').querySelector('.product-rail');
  if (rail) rail.scrollBy({left: Number(control.dataset.railStep) * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["judgeme-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function connectReviews(root) {
      const sections = root.matches?.('[data-product-reviews]') ? [root] : root.querySelectorAll('[data-product-reviews]');
      sections.forEach(section => {
        const widget = section.querySelector('#judgeme_product_reviews');
        const fallback = section.querySelector('[data-review-fallback]');
        if (!widget || !fallback || section.dataset.reviewConnected) return;
        section.dataset.reviewConnected = 'true';
        const update = () => {
          const rendered = widget.querySelector('.jdgm-rev-widg, .jdgm-rev, .jm-review-widget');
          if (rendered && !rendered.closest('.jdgm-legacy-widget-content')) {
            fallback.hidden = true;
            observer.disconnect();
          }
        };
        const observer = new MutationObserver(update);
        observer.observe(widget, { childList:true, subtree:true });
        update();
        const unload = event => {
          if (!event.target.contains(section)) return;
          observer.disconnect();
          document.removeEventListener('shopify:section:unload', unload);
        };
        document.addEventListener('shopify:section:unload', unload);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => connectReviews(document), { once:true });
    else connectReviews(document);
    document.addEventListener('shopify:section:load', event => connectReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["life-stories"] && !Shopify.designMode) return;
  try {
    
(() => { document.querySelectorAll('[data-living-legacy]').forEach((root) => { const dialog=root.querySelector('.ll-quiz'); if(!dialog)return; const steps=[...dialog.querySelectorAll('[data-step]')], progress=dialog.querySelector('.ll-quiz__progress i'), answers={}; const show=(n)=>{steps.forEach((s)=>s.classList.toggle('is-active',Number(s.dataset.step)===n));progress.style.width=`${n*25}%`;}; root.querySelectorAll('.ll-open-quiz').forEach((b)=>b.addEventListener('click',()=>{dialog.showModal();show(1);})); dialog.querySelector('.ll-quiz__close').addEventListener('click',()=>dialog.close()); dialog.addEventListener('click',(e)=>{if(e.target===dialog)dialog.close();}); dialog.querySelectorAll('.ll-options').forEach((group)=>{const multi=group.classList.contains('ll-options--multi');group.querySelectorAll('button').forEach((b)=>b.addEventListener('click',()=>{if(multi){b.classList.toggle('is-selected');answers[group.dataset.name]=[...group.querySelectorAll('.is-selected')].map((x)=>x.dataset.value).join(', ');}else{group.querySelectorAll('button').forEach((x)=>x.classList.remove('is-selected'));b.classList.add('is-selected');answers[group.dataset.name]=b.dataset.value;show(Number(b.closest('[data-step]').dataset.step)+1);}}));}); dialog.querySelector('.ll-quiz__next').addEventListener('click',()=>show(3)); dialog.querySelector('form').addEventListener('submit',()=>{dialog.querySelector('[data-quiz-summary]').value=JSON.stringify(answers);}); }); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["living-desire-v2"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-ld2]').forEach(root=>{const modal=root.querySelector('.ld2-modal'),steps=[...modal.querySelectorAll('[data-step]')],result=modal.querySelector('[data-result]'),bar=modal.querySelector('.ld2-progress i'),summary=modal.querySelector('[data-summary]'),answers={};let current=1;const show=n=>{current=Math.max(1,Math.min(5,n));steps.forEach(s=>s.classList.toggle('is-active',+s.dataset.step===current));result.classList.remove('is-active');bar.style.width=`${current*20}%`};root.querySelectorAll('.ld2-apply-open').forEach(b=>b.addEventListener('click',()=>{root.classList.add('is-form-open');modal.showModal();show(1)}));modal.querySelector('.ld2-close').addEventListener('click',()=>{modal.close();root.classList.remove('is-form-open')});modal.addEventListener('close',()=>root.classList.remove('is-form-open'));modal.querySelectorAll('.ld2-options').forEach(g=>g.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>{if(g.classList.contains('multi'))b.classList.toggle('is-selected');else{g.querySelectorAll('button').forEach(x=>x.classList.remove('is-selected'));b.classList.add('is-selected')}answers[g.dataset.name]=[...g.querySelectorAll('.is-selected')].map(x=>x.textContent.trim()).join(', ')})));modal.querySelectorAll('.ld2-next').forEach(b=>b.addEventListener('click',()=>show(current+1)));modal.querySelectorAll('.ld2-back').forEach(b=>b.addEventListener('click',()=>show(current-1)));root.querySelectorAll('[data-demo]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-demo]').forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');const copy={conversation:'Fan preference → Creator Twin response',voice:'Approved voice reference → AI Twin voice experience',media:'Fan preference → Approved style → Personalized result',device:'Creator Twin → Compatible experience'};root.querySelector('[data-demo-copy]').textContent=copy[b.dataset.demo]}));modal.querySelector('form').addEventListener('submit',()=>{summary.value=JSON.stringify(answers)});root.querySelectorAll('.ld2-faq details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)root.querySelectorAll('.ld2-faq details').forEach(x=>{if(x!==d)x.open=false})}));if(modal.querySelector('[data-application-received]')){steps.forEach(s=>s.classList.remove('is-active'));result.classList.add('is-active');bar.style.width='100%';root.classList.add('is-form-open');modal.showModal()}const heroBtn=root.querySelector('.ld2-hero .ld2-apply-open'),final=root.querySelector('.ld2-final'),sticky=root.querySelector('.ld2-sticky');if('IntersectionObserver'in window){let heroVisible=true,finalVisible=false;const update=()=>sticky.classList.toggle('is-visible',!heroVisible&&!finalVisible);new IntersectionObserver(e=>{heroVisible=e[0].isIntersecting;update()}).observe(heroBtn);new IntersectionObserver(e=>{finalVisible=e[0].isIntersecting;update()}).observe(final)}})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["living-desire"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-living-desire]').forEach(root=>{const d=root.querySelector('.ld-apply'),steps=[...d.querySelectorAll('[data-step]')],bar=d.querySelector('.ld-apply__progress i'),answers={};const show=n=>{steps.forEach(s=>s.classList.toggle('is-active',+s.dataset.step===n));bar.style.width=`${n*20}%`};root.querySelectorAll('.ld-open-apply').forEach(b=>b.onclick=()=>{d.showModal();show(1)});d.querySelector('.ld-apply__close').onclick=()=>d.close();d.addEventListener('cancel',e=>{e.preventDefault()});d.querySelectorAll('.ld-options').forEach(g=>g.querySelectorAll('button').forEach(b=>b.onclick=()=>{if(g.classList.contains('ld-options--multi')){b.classList.toggle('is-selected');answers[g.dataset.name]=[...g.querySelectorAll('.is-selected')].map(x=>x.textContent.trim()).join(', ')}else{g.querySelectorAll('button').forEach(x=>x.classList.remove('is-selected'));b.classList.add('is-selected');answers[g.dataset.name]=b.textContent.trim();show(+b.closest('[data-step]').dataset.step+1)}}));d.querySelectorAll('.ld-next').forEach(b=>b.onclick=()=>show(+b.closest('[data-step]').dataset.step+1));d.querySelector('form').addEventListener('submit',()=>d.querySelector('[data-ld-summary]').value=JSON.stringify(answers))})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["living-legacy-v2"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-ll2]').forEach(root=>{const how=(window.__ll2t&&window.__ll2t.how)||['Start with yourself or someone you love.','Thoughtful questions help bring back stories you may never think to ask about.','Voice, photos, video and written memories come together in one clear life timeline.','Return to stories, family connections and meaningful creations in one living record.'];root.querySelectorAll('[data-how]').forEach(b=>b.onclick=()=>{root.querySelectorAll('[data-how]').forEach(x=>x.classList.remove('is-active'));b.classList.add('is-active');root.querySelector('[data-how-copy]').textContent=how[+b.dataset.how-1]});const q=root.querySelector('.ll2-quiz'),steps=[...q.querySelectorAll('[data-step]')],answers={};const show=n=>{steps.forEach(s=>s.classList.toggle('is-active',+s.dataset.step===n));q.querySelector('.ll2-q-progress i').style.width=`${Math.min(n,4)*25}%`};root.querySelectorAll('.ll2-open').forEach(b=>b.onclick=()=>{q.showModal();show(1)});q.querySelector('.ll2-q-close').onclick=()=>q.close();q.querySelectorAll('.ll2-options').forEach(g=>g.querySelectorAll('button').forEach(b=>b.onclick=()=>{if(g.classList.contains('is-multi')){b.classList.toggle('is-selected');answers[g.dataset.name]=[...g.querySelectorAll('.is-selected')].map(x=>x.dataset.value||x.textContent.trim()).join(', ');g.parentElement.querySelector('.ll2-next').disabled=!answers[g.dataset.name]}else{g.querySelectorAll('button').forEach(x=>x.classList.remove('is-selected'));b.classList.add('is-selected');answers[g.dataset.name]=b.dataset.value||b.textContent.trim();if(g.dataset.name==='person'){answers.personLabel=b.textContent.trim();q.querySelector('[data-email-title]').textContent=(window.__ll2t?window.__ll2t.email.replace(/\$\{[^}]+\}/,answers.personLabel):`Let’s build a starter plan for ${answers.person}.`)};setTimeout(()=>show(+g.closest('[data-step]').dataset.step+1),250)}}));q.querySelector('.ll2-next').onclick=()=>show(3);q.querySelector('form').addEventListener('submit',async e=>{e.preventDefault();q.querySelector('[data-summary]').value=JSON.stringify(answers);const goals=answers.goals||'',challenge=answers.challenge||'';let plan='Living Legacy',start=(window.__ll2t?window.__ll2t.startQ:'Start with five guided questions.');if(goals.includes('Family history')){plan='Family';start=(window.__ll2t?window.__ll2t.startPeople:'Start with the people closest to the story.')}else if(goals.includes('voice')||challenge.includes('writing')||challenge.includes('voice'))start=(window.__ll2t?window.__ll2t.startVoice:'Start with a 10-minute voice conversation.');else if(goals.includes('Photos')){plan='Story';start=(window.__ll2t?window.__ll2t.startPhotos:'Start with three meaningful photographs.')}q.querySelector('[data-result-for]').textContent=(window.__ll2t?window.__ll2t.resultFor.replace(/\$\{[^}]+\}/,answers.personLabel||answers.person||window.__ll2t.yourFamily):`For ${answers.person||'your family'}`);q.querySelector('[data-recommended]').textContent=plan;q.querySelector('[data-starting-point]').textContent=start;try{const r=await fetch(e.target.action,{method:'POST',body:new FormData(e.target),headers:{Accept:'application/json'}});q.querySelector('[data-submit-status]').textContent=r.ok?(window.__ll2t?window.__ll2t.statusSaved:'Starter plan saved.'):(window.__ll2t?window.__ll2t.statusReady:'Your plan is ready. Email delivery could not be confirmed.')}catch(err){q.querySelector('[data-submit-status]').textContent=(window.__ll2t?window.__ll2t.statusReady:'Your plan is ready. Email delivery could not be confirmed.')}show(5)});const c=root.querySelector('.ll2-checkout');root.querySelectorAll('.ll2-plan').forEach(b=>b.onclick=()=>{q.close();c.querySelector('[data-selected-plan]').textContent=b.dataset.plan;c.querySelector('[data-plan-input]').value=b.dataset.plan;c.showModal()});c.querySelector('.ll2-checkout-close').onclick=()=>c.close();})})();

  } catch(e) { console.error(e); }
})();
})();
